import React from 'react';

function Domain({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path strokeWidth="1" d="M1 10L2.5 15L4 10.5L5.5 15L7 10" />
      <path strokeWidth="1" d="M9 10L10.5 15L12 10.5L13.5 15L15 10" />
      <path strokeWidth="1" d="M17 10L18.5 15L20 10.5L21.5 15L23 10" />
      <path
        strokeWidth="1"
        d="M14.3728 18.4897C13.5371 20.1611 12.623 20.7 12 20.7C11.377 20.7 10.463 20.1611 9.62723 18.4897C9.54893 18.3331 9.4732 18.1697 9.40029 18H7.99964C8.32234 18.8592 8.71263 19.6111 9.15473 20.2241C7.82842 19.7653 6.64762 18.9947 5.69999 18H3.99928C5.82369 20.4289 8.72837 22 12 22C15.2716 22 18.1763 20.4289 20.0007 18H18.3C17.3524 18.9947 16.1716 19.7653 14.8453 20.2241C15.2874 19.6111 15.6777 18.8592 16.0004 18H14.5997C14.5268 18.1697 14.4511 18.3331 14.3728 18.4897ZM20.6622 7C18.9331 4.01099 15.7014 2 12 2C8.2986 2 5.06688 4.01099 3.33783 7H4.87942C5.92084 5.51963 7.4122 4.37868 9.15473 3.77591C8.54846 4.61649 8.03962 5.71834 7.66892 7H9.02791C9.20309 6.4546 9.40478 5.95522 9.62723 5.51031C10.463 3.83886 11.377 3.3 12 3.3C12.623 3.3 13.5371 3.83886 14.3728 5.51031C14.5952 5.95522 14.7969 6.4546 14.9721 7H16.3311C15.9604 5.71834 15.4516 4.61649 14.8453 3.77591C16.5878 4.37867 18.0792 5.51963 19.1206 7H20.6622Z"
      />
    </svg>
  );
}

export default Domain;
